import { loadName } from 'helpers/loads';

export const LOADS_PER_PAGE = 5;

export const cutSheetPresent = (productTypes, {prefix, pitch}={}) => {
  const productType = _.find(productTypes, {prefix});
  return !!productType?.cut_sheets?.[pitch];
};

const calculationPages = (loads) => _.uniq(_.map(loads, 'pileType')).length;
const capacityPages = (loads) => loads.length > 1 ? _.ceil(loads.length / LOADS_PER_PAGE) : 0;
const firstLoadPageNumber = (loads) => 2 + capacityPages(loads) + calculationPages(loads);

export function cutSheetPages({data: {loads}}, productTypes) {
  let page = firstLoadPageNumber(loads);
  return _.fromPairs(_.reduce(loads,
    (result, load) => {
      page = page + 2;
      if (cutSheetPresent(productTypes, load.pileOptions)) {
        page++;
        return [...result, [page, _.pick(load.pileOptions, 'prefix', 'pitch')]];
      }
      if (load.product?.cut_sheet?.url) {
        page++;
        result = [...result, [page, {push_pier: load.product.sku}]];
      }
      if (load.ram?.cut_sheet?.url) {
        page++;
        result = [...result, [page, {ram: load.ram.sku}]];
      }
      return result;
    }, []
  ));
}

function loadPageReportIndex(page, loads, productTypes) {
  return _.flatMap(loads,
    (load, i) => {
      const loadTitle = loads.length > 1 ? `${loadName(load, i)} ` : '';
      return _.compact([
        {title: `${loadTitle}Pile Configuration`, pageNumber: ++page},
        {title: `${loadTitle}Graphical Results`, pageNumber: ++page},
        cutSheetPresent(productTypes, load.pileOptions) && {
          title: `Helical Pile Cut Sheet ${load.pileOptions.prefix}`, pageNumber: ++page
        },
        load.product?.cut_sheet?.url && {
          title: `Push Pier Cut Sheet ${load.product.sku}`, pageNumber: ++page
        },
        load.ram?.cut_sheet?.url && {
          title: `Ram Kit Cut Sheet ${load.ram.sku}`, pageNumber: ++page
        },
      ]);
    }
  );
}

export function reportPageIndex({data: {loads}}, productTypes) {
  let page = 2;
  const capacityPageCount = capacityPages(loads);
  const standardPages = _.compact([
    {title: "Introduction", pageNumber: page},
    {title: "Approximate Pile Locations", pageNumber: page},
    {title: "Design Options", pageNumber: page},
    {title: "Design Loads", pageNumber: capacityPageCount > 1 ? `${page += 1}-${page += capacityPageCount - 1}` : page += capacityPageCount},
    _.some(loads, {pileType: 'helical'}) && {title: "Engineering Logic - Helical Piles", pageNumber: ++page},
    _.some(loads, {pileType: 'push_pier'}) && {title: "Engineering Logic - Push Piers", pageNumber: ++page},
    {title: "Baseline Soil Profile", pageNumber: ++page},
  ]);
  const loadPages = loadPageReportIndex(page, loads, productTypes);
  return [
    ...standardPages,
    ...loadPages,
    {title: "Limitations and Conditions of Use", pageNumber: _.last(loadPages).pageNumber + 1},
  ];
}
